import React from 'react';



type Props = {
  className?: string;
}
export const CVDuplicateVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '16' height = '16' viewBox = '0 0 16 16' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path fill = 'currentColor' stroke = 'currentColor' strokeWidth = '0.4' d = 'M10.8421 1H3.26316C2.56842 1 2 1.57273 2 2.27273V11.1818H3.26316V2.27273H10.8421V1ZM12.7368 3.54545H5.78947C5.09474 3.54545 4.52632 4.11818 4.52632 4.81818V13.7273C4.52632 14.4273 5.09474 15 5.78947 15H12.7368C13.4316 15 14 14.4273 14 13.7273V4.81818C14 4.11818 13.4316 3.54545 12.7368 3.54545ZM12.7368 13.7273H5.78947V4.81818H12.7368V13.7273Z' />
    </svg>
  );
};
